export default function CartSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-7xl px-4 py-8">
        <div className="h-8 w-48 bg-surface-2 rounded-lg animate-pulse mb-8" />
        
        <div className="space-y-4">
          {[1, 2].map((i) => (
            <div key={i} className="rounded-2xl bg-surface-1 border border-border/50 p-6 flex gap-6">
              <div className="h-24 w-24 rounded-lg bg-surface-2 animate-pulse" />
              <div className="flex-1 space-y-2">
                <div className="h-6 w-3/4 bg-surface-2 rounded-lg animate-pulse" />
                <div className="h-4 w-1/2 bg-surface-2 rounded-lg animate-pulse" />
                <div className="h-8 w-32 bg-surface-2 rounded-lg animate-pulse" />
              </div>
              <div className="h-8 w-24 bg-brand-glow/20 rounded-lg animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
